export const httpErrorCodes = {
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  UNPROCESSABLE_ENTITY: '422',
  METHOD_NOT_ALLOWED: '405',
  INTERNAL_SERVER_ERROR: '500',
  SERVICE_UNAVAILABLE: '503',
};

export const pageName = {
  ACCOUNTS_PAGE: 'ACCOUNTS_PAGE',
  TEAMS_PAGE: 'TEAMS_PAGE',
  WORKSPACE_PAGE: 'WORKSPACE_PAGE',
  COHORT_OVERVIEW: 'COHORT_OVERVIEW',
  COHORT_PAGE:'COHORT_PAGE',
  COHORT_COURSEWARE_PAGE: 'COHORT_COURSEWARE_PAGE',
  ACTIVITY_EDITOR_PAGE: 'ACTIVITY_EDITOR_PAGE',
  OWNER_WORKSPACES_PAGE: 'OWNER_WORKSPACES_PAGE',
  ACTIVITY_BUILDER: 'ACTIVITY_BUILDER',
  COURSE_COMPETENCY_PAGE: 'COURSE_COMPETENCY_PAGE',
  COURSE_CONTENT_PAGE: 'COURSE_CONTENT_PAGE',
  COURSE_SCORING_PAGE: 'COURSE_SCORING_PAGE',
  KNOWLEDGE_BUILDER_PAGE: 'KNOWLEDGE_BUILDER_PAGE',
  CONTENT_PAGE: 'CONTENT_PAGE',
  LESSON_BUILDER_PAGE: 'LESSON_BUILDER_PAGE',
  SCREEN_EDITOR_PAGE: 'SCREEN_EDITOR_PAGE',
};

/** Immutable fields for Pearson / internal base analytics (GTM). */
export const baseGtmAnalyticsConstants = Object.freeze({
  app_id: 'Bronte',
  platform: 'Web',
});

export const defaultGTMDataLayerPayload = {
  product_id: null, // NA 
  product_platform_code: 'BRONTE', // BRONTE
  product_model_name: 'BRONTE', // BRONTE,
  business_model_code: null, // directToLearner, courseWare
  secondary_person_id: null,
  secondary_person_id_type: null,
  secondary_person_role_code: null,
  person_id_type:'BRONTE-INTERNAL',
};

export const GTM_EVENT_TYPES = {
  PAGEVIEW: 'pageview',
  USER_INTERACTION: 'user_interaction',
  USER_EXCEPTION: 'user_exception',
  GLOBAL_LAUNCH: 'global_launch',
  GLOBAL_OBLIGATORY_LAUNCH: 'global_obligatory_launch', // login, logout
  TRACK_USER_INTERACTION: 'track_user_interaction',
};

export const GTM_EVENT_COMPONENT_ID = {
  AUTHORING_COURSE_CONTENT: 'Authoring-CourseContent',
  AUTHORING_DASHBOARD: 'Authoring-Dashboard',
  AUTHORING_PUBLICATION: 'Authoring-Publication',
  AUTHORING_SCREEN_VIEW: 'Authoring-Screen View',
  AUTHORING_SECTION_SETTINGS: 'Authoring-Section Settings',
  AUTHORING_CONTENT_TOC: 'Authoring-Content TOC',
};

export const GTM_EVENT_CATEGORY = {
  DASHBOARD: 'Dashboard',
  COURSE_PROJECT_DASHBOARD: 'Course Project Dashboard',
  COURSE_PUBLICATION_CREATION:'Publication Creation',
  COURSE_PUBLICATION: 'Publication',
  SCREEN_VIEW: 'Screen View',
  SECTION_SETTINGS: 'Section Settings',
  SECTION_CONTENT: 'Section Content',
  CONTENT_TOC: 'Content TOC',
  COMPONENT_TOOL: 'Component Tool',
};
export const GTM_EVENT_ACTION = {
  SELECT_WORKSPACE: 'Select Workspace',
  CLICK_OPEN_COURSE_PROJECT: 'Click Open Course Project',
  CLICK_CREATE_NEW_COURSE_PROJECT: 'Click Create New Course Project',
  CLICK_BRONTE_TABLE_OF_CONTENTS_OBJECT: 'Click Bronte Table Of Contents Object',
  CLICK_NAVIGATE_TO_CONTENT_IMPORT_HISTORY: 'Click Navigate to Content Import History',
  CLICK_NAVIGATE_TO_PUBLICATION_DETAILS: 'Click Navigate To Publication Details',
  CLICK_OPEN_COURSE_CONTENT: 'Click Open Course Content',
  SELECT_IMPORT_CONTENT_TYPE_FROM_DROPDOWN: 'Select Import Content Type From Dropdown',
  SELECT_IMPORT_FORMAT_FROM_DROPDOWN: 'Select Import Format From Dropdown',
  CLICK_TO_COMPLETE_IMPORT: 'Click To Complete Import',
  SELECT_COURSE_PROJECT_THEME: 'Select Course Project Theme',
  SELECT_COURSE_PUBLICATION_OUTPUT:'Select Publication Output',
  CLICK_TO_COMPLETE_PUBLICATION_CREATION:'Click To Complete Publicaton Creation',
  CLICK_TO_START_FORMAL_PUBLICATION:'Click To Complete Publicaton Creation',
  SELECT_ORGNISATION_LEVEL:'Select Organizational Level',
  CLICK_SCREEN_FROM_LESSON_LIST: 'Click Screen From Lesson List',
  CLICK_BACKGROUND_COLOR_SELECTOR: 'Click Background Color Selector',
  TOGGLE_ROWS_FULL_WIDTH: 'Toggle Rows Full Width',
  KEYSTROKE_CSS_CLASS: 'Keystroke CSS Class',
  CLICK_ADD_OUTPUT_TYPE: 'Click Add Output Type',
  CLICK_PREVIEW_COURSE_CONTENT: 'Click Preview Course Content',
  CLICK_EXPAND_CONTENT_CHAPTER: 'Click Expand Content Chapter',
  CLICK_LESSON_IN_CHAPTER: 'Click Lesson In Chapter',
  CLICK_DESIGN_OPTIONS_MENU: 'Click Design Options Menu',
  CLICK_ICON_LIBRARY_TOGGLE: 'Click Icon Library Toggle',
  CLICK_UNDO_REDO: 'Click Edit Undo Redo',
  SELECT_OPTION_FROM_SCREEN_MENU: 'Select Action From Screen Option Menu',
  SELECT_CODE_BLOCK_COMPONENT: 'Select Code Block Component',
  SELECT_ELEMENT_TO_ADD_FROM_DROPDOWN: 'Select Element to Add From Dropdown',
  DRAG_COMPONENT_TO_ADD: 'Drag Component To Add',
  DRAG_TOOL_TO_ADD: 'Drag Tool To Add ',
};

export const RTE_TOOLBAR_DROPDOWN_ELEMENTS_LIST = [
  'Key Term', 'Footnote', 'Show/Hide', 'External Link', 'Reference', 'Reference Link', 'Inline Icon', 'Styled Text', 'ToolTip', 'Inline Dropdown', 'Inline Text', 'App Opener', 'Dynamic Text', 'iLabs Color Picker',
];

export const GTM_CDP_TRACK_PAGEVIEW_EVENT = "gtm.track.pageview.event";
export const GTM_CDP_TRACK_USER_INTERACTION_EVENT = "gtm.track.user.interaction.event";
export const GTM_CDP_TRACK_USER_EXCEPTION_EVENT = "gtm.track.user.exception.event";
export const TRACK_USER_INTERACTION = "track.user.interaction";

export const GTM_CDP_EVENT_NAMES = [
  GTM_CDP_TRACK_PAGEVIEW_EVENT,
  GTM_CDP_TRACK_USER_INTERACTION_EVENT,
  GTM_CDP_TRACK_USER_EXCEPTION_EVENT,
  TRACK_USER_INTERACTION,
];
